<template>
    <div class="vue-range-filter">
        <vue-range-slider
            v-model="value"
            height="4"
            tooltip="hover"
            :step="step"
            :dot-size="22"
            :min.number="min"
            :max.number="calculatedMax"
            :formatter="formatter"
            @drag-end="handleDragEnd"
            :show="show"
        ></vue-range-slider>

        <template v-if="show === false">
            <p><small>{{ filterResultsText }}</small></p>
        </template>

        <template v-if="showMeta">
            <div class="range-meta d-flex justify-content-between align-items-center">
                <span class="min">{{ this.formatter(this.value[0]) }}</span>
                <span class="max">{{ this.formatter(this.value[1]) }}</span>
            </div>
        </template>
    </div>
</template>

<script>
import './../../../../../themes/custom/ef2_custom/node_modules/vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from './../../../../../themes/custom/ef2_custom/node_modules/vue-range-component'
import baseFilter from '../mixins/baseFilter';
import translationsMixin from '../../../../../themes/custom/ef2_custom/js/vue/mixins/translations.js'

export default {
    name: "OccasionRangeFilter",

    mixins: [baseFilter, translationsMixin],

    props: {
        min: {
            required: true,
            type: Number
        },
        max: {
            required: true,
            type: Number
        },
        step: {
            default: 1,
            type: Number
        },
        formatter: {
            default: value => value,
            type: Function
        },
        showMeta: {
            type: Boolean,
            default: false
        }
    },

    components: {
        VueRangeSlider
    },

    data() {
        return {
            value: [this.min, this.max]
        }
    },

    computed: {
        show() {
            return this.min !== this.max;
        },

        calculatedMax() {
            if (this.step > this.max) {
                return this.step;
            }

            let stepModulo = this.step - ((this.max - this.min) % this.step);

            if (stepModulo === 0) {
                return this.max;
            }

            return this.max + stepModulo;
        },

        localStorageValue() {
            let localStorageFilters = localStorage.getItem('appliedFilters');

            if (lodash.isNil(localStorageFilters)) {
                return null;
            }

            localStorageFilters = JSON.parse(localStorage.getItem('appliedFilters'));

            if (lodash.isNil(localStorageFilters) || _.isEmpty(localStorageFilters)) {
                return null;
            }

            let localStorageEntry = _.find(localStorageFilters, {'key': this.filterKey});

            if (lodash.isNil(localStorageEntry) || lodash.isNil(localStorageEntry.min) || lodash.isNil(localStorageEntry.max) || _.isEmpty(localStorageEntry)) {
                return null;
            }

            return [localStorageEntry.min, localStorageEntry.max];
        }
    },

    methods: {
        handleDragEnd: _.debounce(function (payload) {
            this.eventBus.$emit('range-filter-changed', {
                filterKey: this.filterKey,
                min: payload.currentValue[0],
                max: payload.currentValue[1],
                type: 'range'
            });
        }, 50)
    },

    mounted() {
        if (! lodash.isNil(this.localStorageValue)) {
            this.value = this.localStorageValue;
        }
    },

    watch: {
        min() {
            this.value = [this.min, this.calculatedMax];
        },

        max() {
            this.value = [this.min, this.calculatedMax];
        }
    }
}
</script>
